<template>
  <div>
    <div :class="['flex', compact ? 'gap-1.5' : 'gap-2']">
      <textarea
        :ref="el => autoFocusTextarea(el)"
        :value="modelValue"
        placeholder="Add your instructions here..."
        :disabled="isProcessing"
        style="font-size: 16px"
        :class="[
          'flex-1 resize-none rounded-md border border-gray-300 outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600',
          compact ? 'min-h-[36px] px-2 py-1' : 'min-h-[44px] px-3 py-2'
        ]"
        data-testid="pinning-composer"
        @input="emit('update:modelValue', $event.target.value)"
        @keydown="handleKeyDown"
      />
    </div>
    <div :class="['flex justify-end', compact ? 'mt-1 gap-1.5' : 'mt-2 gap-2']">
      <button
        type="button"
        :class="[
          'cursor-pointer border-none bg-transparent font-medium text-gray-500 hover:text-gray-700',
          compact ? '!text-[11px]' : 'text-xs'
        ]"
        :disabled="isRemoving"
        data-testid="pin-composer-cancel"
        @click="emit('cancel')"
      >
        {{ isRemoving ? "Removing..." : "Cancel" }}
      </button>
      <button
        type="button"
        :class="[
          'cursor-pointer rounded-[4px] border-none bg-[#414192] font-bold !text-white hover:bg-[#06065a] disabled:cursor-not-allowed disabled:opacity-50',
          compact ? 'px-2.5 py-0.5 !text-[11px]' : 'px-4 py-1.5 text-xs'
        ]"
        :disabled="isProcessing || !canSubmit"
        data-testid="pinning-send"
        @click="emit('submit')"
      >
        Submit
      </button>
    </div>
  </div>
</template>

<script setup>
import { nextTick } from "vue";

defineOptions({ name: "PinComposer" });

const props = defineProps({
  modelValue: { type: String, default: "" },
  canSubmit: { type: Boolean, default: false },
  isProcessing: { type: Boolean, default: false },
  isRemoving: { type: Boolean, default: false },
  compact: { type: Boolean, default: false }
});

const emit = defineEmits(["update:modelValue", "submit", "cancel", "newline", "textarea-ref"]);

let prevTextareaEl = null;

function autoFocusTextarea(el) {
  emit("textarea-ref", el);
  if (el && el !== prevTextareaEl) {
    prevTextareaEl = el;
    nextTick(() => el.focus());
  }
  if (!el) {
    prevTextareaEl = null;
  }
}

function handleKeyDown(e) {
  if (e.key === "Enter") {
    if (e.metaKey || e.ctrlKey) {
      e.preventDefault();
      const { selectionStart, selectionEnd } = e.target;
      const val = props.modelValue;
      const newValue = `${val.slice(0, selectionStart)}\n${val.slice(selectionEnd)}`;
      emit("update:modelValue", newValue);
      emit("newline", selectionStart + 1);
      return;
    }
    e.preventDefault();
    if (!props.isProcessing && props.canSubmit) {
      emit("submit");
    }
  }
}
</script>
